import React, { useEffect, useState } from "react";
import axios from "axios";

export default function EmployeeOnboarding() {
  const token = localStorage.getItem("token");

  const [status, setStatus] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState({
    resume_url: "",
    id_proof_url: "",
    bank_doc_url: "",
  });

  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    personal_email: "",
    phone: "",
    dob: "",
    gender: "",
    bank_account: "",
    ifsc: "",
    address: "",
    emergency_name: "",
    emergency_relation: "",
    emergency_phone: "",
    resume: null,
    id_proof: null,
    bank_doc: null,
  });

  // Fetch employee data
  useEffect(() => {
    axios
      .get("https://smart-hr.shopattropical.com/api/employee/me", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setForm((prev) => ({ ...prev, ...res.data }));
        setStatus(res.data.onboarding_status);
        setUploadedFiles({
          resume_url: res.data.resume_url,
          id_proof_url: res.data.id_proof_url,
          bank_doc_url: res.data.bank_doc_url,
        });
      })
      .catch(() => alert("Failed to load your data"));
  }, [token]);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleFileChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.files[0] });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!uploadedFiles.resume_url && !form.resume)
      return alert("Resume required");
    if (!uploadedFiles.id_proof_url && !form.id_proof)
      return alert("ID Proof required");
    if (!uploadedFiles.bank_doc_url && !form.bank_doc)
      return alert("Bank Document required");

    try {
      const formData = new FormData();
      Object.keys(form).forEach((key) => {
        if (form[key]) formData.append(key, form[key]);
      });

      const res = await axios.put(
        "https://smart-hr.shopattropical.com/api/employee/onboarding",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setUploadedFiles({
        resume_url: res.data.resume_url,
        id_proof_url: res.data.id_proof_url,
        bank_doc_url: res.data.bank_doc_url,
      });
      setStatus("COMPLETED");
      alert("Onboarding saved successfully");
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Upload failed");
    }
  };

  const FileBlock = ({ label, url, name }) => {
    const [previewName, setPreviewName] = useState("");
    const fileValue = form[name];

    useEffect(() => {
      if (fileValue) setPreviewName(fileValue.name);
      else setPreviewName("");
    }, [fileValue]);

    return (
      <div className="col-span-2 border p-3 rounded">
        <p className="font-semibold">{label}</p>
        {url || previewName ? (
          <div className="text-green-600 font-semibold">
            Uploaded ✔
            {url && (
              <a
                href={`https://smart-hr.shopattropical.com${url}`}
                target="_blank"
                rel="noreferrer"
                className="text-blue-600 underline ml-2"
              >
                View
              </a>
            )}
            {previewName && !url && <span className="ml-2">({previewName})</span>}
          </div>
        ) : (
          <p className="text-red-500">Not uploaded</p>
        )}
        <input type="file" name={name} onChange={handleFileChange} />
        <small className="text-gray-500">Replace (optional)</small>
      </div>
    );
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Employee Onboarding</h1>

      <p className="mb-4">
        Status:{" "}
        <span className={status === "COMPLETED" ? "text-green-600" : "text-red-600"}>
          {status || "Pending"}
        </span>
      </p>

      <form
        onSubmit={handleSubmit}
        className="grid grid-cols-2 gap-4 bg-white p-6 rounded shadow"
      >
        <input
          name="first_name"
          value={form.first_name}
          onChange={handleChange}
          placeholder="First Name"
          className="border p-2"
        />
        <input
          name="last_name"
          value={form.last_name}
          onChange={handleChange}
          placeholder="Last Name"
          className="border p-2"
        />
        <input
          name="personal_email"
          value={form.personal_email}
          onChange={handleChange}
          placeholder="Email"
          className="border p-2"
        />
        <input
          name="phone"
          value={form.phone}
          onChange={handleChange}
          placeholder="Phone"
          className="border p-2"
        />
        <input
          type="date"
          name="dob"
          value={form.dob}
          onChange={handleChange}
          className="border p-2"
        />
        <select
          name="gender"
          value={form.gender}
          onChange={handleChange}
          className="border p-2"
        >
          <option value="">Select Gender</option>
          <option>Male</option>
          <option>Female</option>
          <option>Other</option>
        </select>

        <input
          name="bank_account"
          value={form.bank_account}
          onChange={handleChange}
          placeholder="Bank Account"
          className="border p-2"
        />
        <input
          name="ifsc"
          value={form.ifsc}
          onChange={handleChange}
          placeholder="IFSC"
          className="border p-2"
        />
        <input
          name="address"
          value={form.address}
          onChange={handleChange}
          placeholder="Address"
          className="border p-2 col-span-2"
        />

        <input
          name="emergency_name"
          value={form.emergency_name}
          onChange={handleChange}
          placeholder="Emergency Name"
          className="border p-2"
        />
        <input
          name="emergency_relation"
          value={form.emergency_relation}
          onChange={handleChange}
          placeholder="Relation"
          className="border p-2"
        />
        <input
          name="emergency_phone"
          value={form.emergency_phone}
          onChange={handleChange}
          placeholder="Phone"
          className="border p-2"
        />

        <FileBlock label="Resume" url={uploadedFiles.resume_url} name="resume" />
        <FileBlock label="ID Proof" url={uploadedFiles.id_proof_url} name="id_proof" />
        <FileBlock label="Bank Document" url={uploadedFiles.bank_doc_url} name="bank_doc" />

        <button className="col-span-2 bg-green-600 text-white p-2 rounded">
          Save / Update Onboarding
        </button>
      </form>
    </div>
  );
}
